<template>
<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" width="8.296mm" height="8.7641mm" version="1.1" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
viewBox="0 0 34477 36422"
 xmlns:xlink="http://www.w3.org/1999/xlink">
 <g id="Pracovní_x0020_plocha">
  <path class="fil0" d="M34096 12262l-15876 -12024c-416,-314 -967,-318 -1388,-7l-16317 12023c-302,222 -515,574 -515,948l0 22141c0,652 621,1079 1271,1079l32202 0c651,0 1004,-427 1004,-1079l0 -22141c0,-370 -86,-718 -381,-940zm-1957 21823l0 0 -29802 0 0 -20289 15075 -11148 14727 11141 0 20296z"/>
 </g>
</svg>
</template>

<script>
export default {
  name: 'HomeLg',
};
</script>

<style scoped>
.fil0 {fill:#666666;fill-rule:nonzero}
</style>
